import React, { useEffect } from 'react';
import {Box, Typography, Button, Container, Fade, Zoom, Paper} from '@mui/material';
import { QrCodeScanner } from '@mui/icons-material';
import '../../styles/appStyles.css';
import {Link, useNavigate} from 'react-router-dom';
import {Link as RouterLink} from "react-router";
import MuiLink from "@mui/material/Link";

const RescanQR = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/');
    };

            useEffect(() => {
        window.scrollTo(0, 0);
            }, []);

            return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{
                minHeight: 'calc(100vh - 120px)',
                py: 5,
                px: 2
            }}
        >
            <Fade in={true} timeout={800}>
                <Paper 
                    elevation={6}
                    sx={{
                        p: 5,
                        borderRadius: '24px',
                        background: 'linear-gradient(135deg, #ffffff, #f8f9fa)',
                        maxWidth: '600px',
                        width: '100%',
                        textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05)',
                        border: '1px solid rgba(255, 255, 255, 0.8)',
                        transform: 'perspective(1000px)',
                        transition: 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)'
                    }}
                >
                    <Typography 
                        variant="h4" 
                        gutterBottom 
                        sx={{
                            fontWeight: 'bold',
                            backgroundImage: 'linear-gradient(45deg, var(--primary-color), var(--secondary-color))',
                            backgroundClip: 'text',
                            textFillColor: 'transparent',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            mb: 3
                        }}
                    >
                        <QrCodeScanner sx={{ fontSize: '2.5rem', mr: 1, verticalAlign: 'bottom' }} />
                        Zeskanuj ponownie kod QR
                    </Typography>

                    <Typography 
                        variant="h6" 
                        gutterBottom
                        sx={{
                            color: 'var(--dark-color)',
                            opacity: 0.8,
                            mb: 4,
                            fontWeight: 500
                        }}
                    >
                        Nie wykryto kodu. Prosimy o ponowne zeskanowanie kodu QR ze stolika.
                    </Typography>

                    <Zoom in={true} style={{ transitionDelay: '300ms' }}>
                        <Box
                            component="div"
                            sx={{
                                position: 'relative',
                                width: '300px',
                                height: '300px',
                                maxWidth: '100%',
                                mx: 'auto',
                                mb: 4,
                                borderRadius: '24px',
                                overflow: 'hidden',
                                boxShadow: '0 15px 35px rgba(0, 0, 0, 0.15)',
                                '&::before': {
                                    content: "''",
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(135deg, rgba(255, 71, 87, 0.2), rgba(83, 82, 237, 0.2))',
                                    zIndex: 1
                                },
                                animation: 'pulse 2s infinite'
                            }}
                        >
                            <Box
                                component="img"
                                src="https://storage.googleapis.com/menu-mate-storage/website_photos/scan-qr.png"
                                alt="zeskanuj QR"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                        </Box>
                    </Zoom>

                    <Button 
                        onClick={handleBack}
                        className="action-button primary-button"
                        sx={{ mt: 2 }}
                    >
                        Odśwież stronę
                    </Button>
                </Paper>
            </Fade>

            <Box component="footer" className="custom-footer" sx={{ width: '100%', mt: 5, borderRadius: 0 }}>
                <Typography variant="body2" sx={{ color: 'white', fontWeight: 500 }}>
                    Menu Mate 2025{' '}
                    <MuiLink 
                        component={RouterLink} 
                        to="/contact" 
                        className="footer-link"
                    >
                        Kontakt
                    </MuiLink>
                </Typography>
            </Box>
        </Box>
    );
};

export default RescanQR;